
import { Vue } from "vue-class-component";
import moment from "moment";
import { set, get, keys, Store } from "idb-keyval";
import { Guid } from "guid-typescript";
import { Match } from "../models/Models";
import axios from 'axios';
import router from '../router';

export default class MatchNew extends Vue {
  
  async goToSpond() {    
    const spondStore = new Store('playmatch-db', 'spond-store');    
    const token = await get('spondToken', spondStore)
    if (token) {
      router.push({ name: "SpondMatches" });
    } else {
      router.push({ name: "SpondLogin" });
    }
  }

  async newMatch() {
    const match: Match = {
      id: Guid.create().toString(),
      homeCount: 0,
      opponent: undefined,
      awayCount: 0,
      isRunning: false,
      hasStarted: false,
      totalSecondsPlayed: 0,
      homeGame: undefined,
      matchPlayedTime: "",
      lastStarted: undefined,
      players: [],
      created: moment().format('YYYY-MM-DD HH:mm:ss')
    };

    await set(match.id, match);

    router.push({ name: "MatchDetails", params: { id: match.id } });
  }
}
